import React, { FC, useEffect } from 'react'
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'

const FieldValidationError: FC<ValueFieldProps> = (props) => {
  const hasAnyError = !!props.errors?.length;

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <>
      {hasAnyError && (
        <div className="sitecore-jss-form__error-list">
          <div>
            {props.errors.map((error, i) => (
              <p key={i}>
                <pfe-icon
                  icon="cnh-alert-triangle-line"
                  size="16"
                  class="sitecore-jss-form__error-list__icon"
                ></pfe-icon>
                {error}
              </p>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default FieldValidationError
